import { useState } from 'react'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { ArrowLeft, Check2 } from 'blaze-ui/icons/20'
import Styles from './StrategyEditDrawer.module.scss'

interface StrategyEditDrawerProps extends DrawerProps {
  title: string
  value: string
  onSave: (value: string) => void
}

export const StrategyEditDrawer = observer(({ title, value, onSave, ...props }: StrategyEditDrawerProps) => {
  const [localValue, setLocalValue] = useState(value)
  const { drawersStore } = useRootStore()

  return (
    <Drawer.Root {...props} activeSnapPoint={1} snapPoints={[1]}>
      <Drawer.Overlay />
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <div style={{ height: '100%' }} data-vaul-no-drag>
            <Drawer.InnerContent isSnappedTop>
              <Drawer.Top>
                <Drawer.Back onPress={() => drawersStore.closeDrawer()} frontIcon={ArrowLeft}>
                  {''}
                </Drawer.Back>
                <Drawer.Title asChild>
                  <Heading lineClamp={1} level={5}>
                    {title}
                  </Heading>
                </Drawer.Title>
                <Drawer.Action
                  onPress={() => {
                    onSave(localValue.trim())
                    drawersStore.closeDrawer()
                  }}
                  frontIcon={Check2}
                  position="right"
                >
                  Save
                </Drawer.Action>
                <Drawer.Description />
              </Drawer.Top>
              <Drawer.ScrollableContainer snap={1}>
                <div className={Styles.container}>
                  <div className={Styles.editorContainer}>
                    <Input
                      isTextarea
                      value={localValue}
                      onChange={(e) => setLocalValue(e.target.value)}
                      name="strategy-edit"
                      size="xl"
                      autoFocus
                    />
                  </div>
                </div>
              </Drawer.ScrollableContainer>
            </Drawer.InnerContent>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
